import { apiClient } from "@/api/api-client";
import { z } from "zod";

const CaseActivityPaymentSchema = z.object({
	id: z.string().nullable(),
	fullname: z.string(),
	email: z.string().email(),
	address: z.string(),
});

const caseActivityPaymentService = {
	getActivityPayments: async (params = {}) => {
		const response = await apiClient.get<{ data: T[]; meta: Pagination }>(
			"backoffice/case-activity-payments",
			{ params },
		);

		return response.data;
	},
};

export default caseActivityPaymentService;
